import { createFileRoute } from '@tanstack/react-router';
import { useFavoriteListStore } from '@features/favoritelist/favoriteListStore.ts';
import UserLayout from '@components/layout/UserLayout.tsx';
import FavoriteProducts from '@features/favoritelist/FavoriteProducts.tsx';
import { z } from 'zod';
import { useFavouritesStore } from '@features/favouries/useFavouritesStore.ts';

const searchSchema = z.object({
  q: z.string().optional().default(''),
});

export const Route = createFileRoute('/c/$orgId/$portalId/favourites')({
  validateSearch: v => searchSchema.parse(v),
  component: RouteComponent,
  beforeLoad: ctx => {
    useFavoriteListStore.getState().loadFavoriteList(ctx.search.q);
    useFavouritesStore.getState().loadFavourites();
  },
});

function RouteComponent() {
  const nav = Route.useNavigate();

  const handleSearch = (query: string) => {
    nav({
      search: p => ({ ...p, q: query }),
    });
  };
  return (
    <>
      <UserLayout>
        <FavoriteProducts handleSearch={handleSearch} />
      </UserLayout>
    </>
  );
}
